import React from 'react';
import {
  createFrontendPlugin,
  ApiBlueprint,
  PageBlueprint,
  NavItemBlueprint,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { createRouteRef } from '@backstage/core-plugin-api';
import { compatWrapper } from '@backstage/core-compat-api';
import { deployMetricsApiRef } from './api/DeployMetricsApi';
import { DeployMetricsClient } from './api/DeployMetricsClient';
import TimelineIcon from '@material-ui/icons/Timeline';

const rootRouteRef = createRouteRef({ id: 'deploy-metrics' });

const deployMetricsPage = PageBlueprint.make({
  name: 'deploy-metrics',
  params: {
    path: '/deploy-metrics',
    routeRef: rootRouteRef,
    loader: async () =>
      import('./components/DeployMetricsPage').then(m =>
        import('./components/DevopsGuard').then(g =>
          compatWrapper(
            React.createElement(
              g.DevopsGuard,
              null,
              React.createElement(m.DeployMetricsPage),
            ),
          ),
        ),
      ),
  },
});

const deployMetricsNavItem = NavItemBlueprint.make({
  name: 'deploy-metrics',
  params: {
    title: 'Métricas',
    icon: TimelineIcon,
    routeRef: rootRouteRef,
  },
});

const deployMetricsApi = ApiBlueprint.make({
  name: 'deploy-metrics',
  params: defineParams =>
    defineParams({
      api: deployMetricsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new DeployMetricsClient({ discoveryApi, fetchApi }),
    }),
});

const deployMetricsPlugin = createFrontendPlugin({
  pluginId: 'deploy-metrics',
  extensions: [deployMetricsPage, deployMetricsNavItem, deployMetricsApi],
  routes: {
    root: rootRouteRef,
  },
});

export default deployMetricsPlugin;
